import React from 'react';

const FieldMapping = ({ 
  headers, 
  mappings, 
  onMappingChange, 
  availableFields,
  title,
  description 
}) => {
  return (
    <div>
      <h4 className="text-md font-medium text-gray-900 mb-2">{title}</h4>
      
      <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mb-6">
        <div className="flex">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-blue-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-blue-800">Field Mapping Guide</h3>
            <div className="mt-2 text-sm text-blue-700">
              <p>{description || 'Map your spreadsheet columns to the system fields below. Required fields are marked with an asterisk (*) and must be mapped before import.'}</p>
              <p className="mt-2">Year and Denomination are required for all coins. All other fields are optional and can be left unmapped.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Required Fields Section */}
      <div className="mb-8">
        <h5 className="text-sm font-medium text-gray-900 mb-4">Required Fields (Year and Denomination)</h5>
        <div className="grid grid-cols-3 gap-4">
          {availableFields
            .filter(field => field.required)
            .map(field => {
              const mappedHeader = Object.entries(mappings).find(([_, value]) => value === field.key)?.[0];
              return (
                <div key={field.key} className="col-span-1">
                  <label className="block text-sm font-medium text-gray-700 mb-1 flex items-center">
                    <span>{field.label} *</span>
                    {field.key === 'year' || field.key === 'denomination' ? (
                      <span className="ml-2 text-xs text-red-600">(Required)</span>
                    ) : null}
                  </label>
                  <select
                    value={mappedHeader || ''}
                    onChange={(e) => {
                      // Remove old mapping if exists
                      if (mappedHeader) {
                        onMappingChange(mappedHeader, '');
                      }
                      // Add new mapping if a column is selected
                      if (e.target.value) {
                        onMappingChange(e.target.value, field.key);
                      }
                    }}
                    className={`block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md ${
                      !mappedHeader && (field.key === 'year' || field.key === 'denomination') ? 'bg-red-50 border-red-300' : 
                      !mappedHeader ? 'bg-yellow-50' : ''
                    }`}
                  >
                    <option value="">-- Select Spreadsheet Column --</option>
                    {headers.map(header => (
                      <option 
                        key={header} 
                        value={header}
                        disabled={Object.values(mappings).includes(header) && mappings[header] !== field.key}
                      >
                        {header}
                      </option>
                    ))}
                  </select>
                </div>
              );
            })}
        </div>
      </div>

      {/* Optional Fields Section */}
      <div>
        <h5 className="text-sm font-medium text-gray-900 mb-4">Optional Fields (Leave unmapped if not in spreadsheet)</h5>
        <div className="grid grid-cols-3 gap-4">
          {availableFields
            .filter(field => !field.required)
            .map(field => {
              const mappedHeader = Object.entries(mappings).find(([_, value]) => value === field.key)?.[0];
              return (
                <div key={field.key} className="col-span-1">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    {field.label}
                  </label>
                  <select
                    value={mappedHeader || ''}
                    onChange={(e) => {
                      // Remove old mapping if exists
                      if (mappedHeader) {
                        onMappingChange(mappedHeader, '');
                      }
                      // Add new mapping if a column is selected
                      if (e.target.value) {
                        onMappingChange(e.target.value, field.key);
                      }
                    }}
                    className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                  >
                    <option value="">-- Select Spreadsheet Column --</option>
                    {headers.map(header => (
                      <option 
                        key={header} 
                        value={header}
                        disabled={Object.values(mappings).includes(header) && mappings[header] !== field.key}
                      >
                        {header}
                      </option>
                    ))}
                  </select>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default FieldMapping;
